import * as yup from 'yup';

import { allgemeinSchema } from '@/features/Sparten/shared/schema/kfz/notPkw/allgemeinSchema/allgemeinSchema';
import { erstfahrzeugSchema } from '@/features/Sparten/shared/schema/kfz/erstfahrzeugSchema/erstfahrzeugSchema';
import { versicherungsnehmerSchema } from '@/features/Sparten/kradv2/schema/versicherungsnehmerSchema/versicherungsnehmerSchema';
import { fahrzeugSchema } from '@/features/Sparten/kradv2/schema/fahrzeugSchema/fahrzeugSchema';
import { baseInputSchema } from '@/features/Sparten/shared/schema/kfz/baseInputSchema';
import { fahrerkreisSchema as kfzFahrerkreisSchema } from '@/features/Sparten/shared/schema/kfz/fahrerkreisSchema/fahrerkreisSchema';

export const kradSchema = baseInputSchema.concat(
  yup.object({
    allgemein: allgemeinSchema,
    erstfahrzeug: erstfahrzeugSchema,
    fahrerkreis: kfzFahrerkreisSchema,
    fahrzeug: fahrzeugSchema,
    sfKlasseKH: yup.string().required().default(''),
    sfKlasseVK: yup
      .string()
      .default('')
      .when('kaskoTyp', {
        is: (val: string) => val === 'vollkasko',
        then: yup.string().required(),
      }),
    versicherungsnehmer: versicherungsnehmerSchema,
    fahrerschutzversicherung: yup.boolean().default(false).required(),
    rabattschutzKfzHaftpflicht: yup.boolean().default(false).required(),
    rabattschutzVollkasko: yup.boolean().default(false).required(),
    // V2-Delta (wie campv2/pkwv2): Pflichtfeld des V2-Backend-Validators.
    hauptfaelligkeitUnterjaehrig: yup.boolean().default(false),
  }),
);
